// Single source of truth for the router and the home index.
// `load` is a thunk, so nothing here pulls a landing into the main bundle.
export const LANDINGS = [
  {
    slug: 'medicinebox',
    title: 'মেডিসিন বক্স (অরিজিনাল ডিজাইন)',
    blurb: 'kathermelabd.com/landing/medicinebox — হুবহু একই ডিজাইন',
    load: () => import('./medicinebox'),
  },
  {
    slug: 'jewelry-box',
    title: 'মেকআপ ও জুয়েলারি অর্গানাইজার',
    blurb: 'kathermelabd.com/landing/jewelry-box — গহনা ও মেকআপ অর্গানাইজার',
    load: () => import('./jewelry-box'),
  },
];
